export default __webpack_public_path__ + "static/surgery-e194bb341da8bf007c5b4bb41b5821c3.jpg";